'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../../..');

var _2 = _interopRequireDefault(_);

var _3 = require('..');

var _4 = _interopRequireDefault(_3);

var _context = require('../../../../../context');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var EditableView = (_temp2 = _class = function (_EditorComponent) {
  _inherits(EditableView, _EditorComponent);

  function EditableView() {
    var _temp, _this, _ret;

    _classCallCheck(this, EditableView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _EditorComponent.call.apply(_EditorComponent, [this].concat(args))), _this), _this.onBeforeDrop = function () {}, _temp), _possibleConstructorReturn(_this, _ret);
  } // canBeParent(parent) {
  //   return parent instanceof EditableObject && super.canBeParent(parent);
  // }


  EditableView.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelEditableView
    }, 'EditableView'));
  };

  EditableView.prototype.renderMainView = function renderMainView() {
    var _this2 = this;

    return _react2.default.createElement(_context.EditableObjectContext.Consumer, null, function (editableObjectContext) {
      var objectInEditMode = editableObjectContext.inEditMode;
      return !objectInEditMode ? null : _EditorComponent.prototype.renderMainView.call(_this2);
    });
  };

  return EditableView;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  hide_wrapper_in_default_mode: true
}), _class.Name = "EditableView", _class.help_url = "https://front-editor.prisma-cms.com/topics/editableobject.html", _temp2);
exports.default = EditableView;
module.exports = exports['default'];